import { Menu, MenuItem } from '@material-ui/core';
import React, { useState, Ref, forwardRef, PropsWithChildren, DOMAttributes, Attributes } from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { enhanceChildrenProps } from '../utils/ChildrenPropsEnhancer';

interface IOwnProps {
    label: string;
}

type ISubMenuItemProps = IOwnProps & Pick<DOMAttributes<HTMLElement>, 'onClick'>;

export const SubMenuItem = forwardRef<SVGSVGElement, PropsWithChildren<ISubMenuItemProps>>(
    (props: PropsWithChildren<ISubMenuItemProps>, ref: Ref<SVGSVGElement>): JSX.Element => {
        const { onClick } = props;

        const [isMenuOpened, setIsMenuOpened] = useState<HTMLElement | undefined>(undefined);
        const handleClose = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
            setIsMenuOpened(undefined);
            onClick && onClick(event);
        };
        const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
            setIsMenuOpened(event.currentTarget);
        };

        const menuItems = enhanceChildrenProps(props, (originalProps: Partial<any> & Attributes) => ({
            ...originalProps,
            onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
                if (originalProps.onClick) {
                    originalProps.onClick(event);
                }
                handleClose(event);
            }
        }));

        return (
            <React.Fragment>
                <MenuItem onClick={handleClick}>
                    {props.label}
                    <ChevronRightIcon ref={ref} />
                </MenuItem>
                <Menu
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                    open={!!isMenuOpened}
                    anchorEl={isMenuOpened}
                    onClose={handleClose}
                >
                    {menuItems}
                </Menu>
            </React.Fragment>
        );
    }
);
SubMenuItem.displayName = 'SubMenuItem';
